export default __webpack_public_path__ + "static/media/temp 2.4374877e.svg";